var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sky-suffix',_vm._b({on:{"search-click":_vm.search}},'sky-suffix',_vm.$attrs,false),[_c('el-input',_vm._b({directives:[{name:"focus",rawName:"v-focus",value:(_vm.focus),expression:"focus"}],attrs:{"type":"textarea","value":_vm.value},on:{"input":_vm.handleChange}},'el-input',_vm.$attrs,false)),_vm._t("toolTips",null,{"slot":"toolTips"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }